var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomStatistics = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.563 14.25c.567 0 1.08-.228 1.46-.593l2.08 1.04c-.01.085-.025.169-.025.256 0 1.163.946 2.11 2.11 2.11 1.163 0 2.109-.947 2.109-2.11 0-.325-.08-.628-.212-.904l2.824-2.823c.275.132.579.211.904.211 1.163 0 2.109-.946 2.109-2.109 0-.219-.043-.426-.105-.625l2.453-1.84c.335.224.736.356 1.168.356 1.163 0 2.109-.947 2.109-2.11C25.547 3.946 24.6 3 23.437 3c-1.163 0-2.109.946-2.109 2.11 0 .218.043.425.105.624l-2.453 1.84a2.095 2.095 0 0 0-1.168-.355c-1.163 0-2.109.946-2.109 2.11 0 .324.08.628.212.903l-2.824 2.823a2.084 2.084 0 0 0-.903-.211c-.568 0-1.081.227-1.46.593l-2.082-1.04c.01-.086.026-.169.026-.256 0-1.163-.946-2.11-2.11-2.11-1.163 0-2.109.947-2.109 2.11 0 1.163.946 2.109 2.11 2.109z",
    fill: "#F6C760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.297 25.594h-.75v-14.86a.703.703 0 0 0-.703-.703H22.03a.703.703 0 0 0-.703.703v14.86h-1.406v-10.64a.703.703 0 0 0-.703-.704h-2.813a.703.703 0 0 0-.703.703v10.64h-1.406v-5.015a.703.703 0 0 0-.703-.703H10.78a.703.703 0 0 0-.703.703v5.016H8.672v-7.828a.703.703 0 0 0-.703-.703H5.156a.703.703 0 0 0-.703.703v7.828h-.75a.703.703 0 1 0 0 1.406h22.594a.703.703 0 1 0 0-1.406z",
    fill: "#1B7690"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomStatistics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-statistics.a3bcd6cff45461b7909eaca401c1711d.svg";